import { render, staticRenderFns } from "./MdEditTable.vue?vue&type=template&id=affecfe4&"
import script from "./MdEditTable.vue?vue&type=script&lang=js&"
export * from "./MdEditTable.vue?vue&type=script&lang=js&"
import style0 from "./MdEditTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports